import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table } from "antd";
import Card from "components/card";
import dayjs from "dayjs";
import { DATE_FORMAT_MDY, TIME_FORMAT_12HM } from "variables/constants";
import Crudoption from "components/dropdown/crudoption";
import { getTimecardUpdateRequestList,
		 approveTimecardUpdateRequest,
		 rejectTimecardUpdateRequest,
		 doTimecardUpdateRequestDelete,
 } from "../../../../../redux/timecardupdaterequest/timecardUpdateRequestState";
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

const TimecardUpdateRequestTable = ({}) => {

	const dispatch = useDispatch();

	const recordList = useSelector(
		(state) => state.timecardUpdateRequest.timecardUpdateRequestList
	);

	useEffect(() => {
		dispatch(
			getTimecardUpdateRequestList({
				page: 1,
				paginate: 10,
			})
		);
	}, [dispatch]);

    const handleTableChange = (pagination) => {
		dispatch(
			getTimecardUpdateRequestList({
				...recordList.filters,
				page: pagination.current,
				paginate: pagination.pageSize,
			})
		)
        dispatch(
			getTimecardUpdateRequestList({
				...recordList.filters,
				page: pagination.current,
				paginate: pagination.pageSize,
			})
		);
    };

	const columns = [
		{
			title: "Employee Name",
			dataIndex: "tur_employee_name",
			key: "tur_employee_name",
			width: "18%",
		},
		{
			title: "Date",
			dataIndex: "tur_date",
			key: "tur_date",
			width: "12%",
			render: (date) =>
				date ? dayjs(date).format(DATE_FORMAT_MDY) : "-",
		},
		{
			title: (
				<>
					<div>Logged /</div>
					<div>Requested Schedule</div>
				</>
			),
			key: "tur_schedule",
			width: "15%",
			render: (_, record) => {
				const scheduleInChanged =
					dayjs(record.tur_requested_schedule_time_in).format("HH:mm:ss") !==
					dayjs(record.tur_original_schedule_time_in).format("HH:mm:ss");
				const scheduleOutChanged =
					dayjs(record.tur_requested_schedule_time_out).format("HH:mm:ss") !==
					dayjs(record.tur_original_schedule_time_out).format("HH:mm:ss");

				return (
					<>
						<div>
							{record.tur_original_schedule_time_in
								? `${dayjs(record.tur_original_schedule_time_in).format(TIME_FORMAT_12HM)}
								- ${dayjs(record.tur_original_schedule_time_out).format(TIME_FORMAT_12HM)}`
								: record.tur_schedule_type_name ?? "-"}
						</div>

						<div>
							<span className={scheduleInChanged ? "text-blue-500" : ""}>
								{record.tur_requested_schedule_time_in
									? dayjs(record.tur_requested_schedule_time_in).format(TIME_FORMAT_12HM)
									: "-"}
							</span>
							{" - "}
							<span className={scheduleOutChanged ? "text-blue-500" : ""}>
								{record.tur_requested_schedule_time_out
									? dayjs(record.tur_requested_schedule_time_out).format(TIME_FORMAT_12HM)
									: "-"}
							</span>
						</div>
					</>
				);
			}
		},
		{
			title: (
				<>
					<div>Logged /</div>
					<div>Requested Punches</div>
				</>
			),
			key: "tur_punch",
			width: "15%",
			render: (_, record) => {
				const punchInChanged =
					dayjs(record.tur_requested_punch_in).format("HH:mm:ss") !==
					dayjs(record.tur_original_punch_in).format("HH:mm:ss");
				const punchOutChanged =
					dayjs(record.tur_requested_punch_out).format("HH:mm:ss") !==
					dayjs(record.tur_original_punch_out).format("HH:mm:ss");

				return (
					<>
						<div>
							{ `${record.tur_original_punch_in
									? dayjs(record.tur_original_punch_in).format(TIME_FORMAT_12HM)
									: ""} - ${
									record.tur_original_punch_out
										? dayjs(record.tur_original_punch_out).format(TIME_FORMAT_12HM)
										: ""
								}`}
						</div>

						<div>
							<span className={punchInChanged ? "text-blue-500" : ""}>
								{record.tur_requested_punch_in
									? dayjs(record.tur_requested_punch_in).format(TIME_FORMAT_12HM)
									: "-"}
							</span>
							{" - "}
							<span className={punchOutChanged ? "text-blue-500" : ""}>
								{record.tur_requested_punch_out
									? dayjs(record.tur_requested_punch_out).format(TIME_FORMAT_12HM)
									: "-"}
							</span>
						</div>
					</>
				);
			}
		},
		{
			title: "Reason",
			dataIndex: "tur_reason",
			key: "tur_reason",
			width: "20%",
			ellipsis: true,
		},
		{
			title: "Status",
			dataIndex: "tur_status_name",
			key: "tur_status_name",
			width: "10%",
			render: (tur_status_name) => (
				<div className={`status-indicator ${tur_status_name?.toLowerCase()}`}>
					{tur_status_name}
				</div>
			),
		},
		{
			// title: <PopupButton id="add_time_card" title="Add Time Card" label="Add" btnClass="btn-small" moduleId={MODULE_TIMECARDS}>
			// 			<TimeCardForm recordId="0" mode="edit"/>
			// 		</PopupButton>,
			dataIndex: 'tur_id',
			key: 'tur_id',
			width: '10%',
			render: (tur_id, record) => 
				<Crudoption
					recordId={record.tur_id}
					allowView={false}
					allowEdit={false}
					allowDelete={false}
					approveHandler={(turId) =>
						dispatch(approveTimecardUpdateRequest({ tur_id: turId }))
					}

					rejectHandler={(turId) =>
						dispatch(rejectTimecardUpdateRequest({ tur_id: turId }))
					}
					// deleteHandler={handleDelete}
					additionalMenu={[
					{
						key: "approve",
						icon: <CheckOutlined />,
						label: "Approve",
						confirm: "approve",
						available: record.tur_status_name === "Pending" ? 1 : 0,
					},
					{
						key: "reject",
						icon: <CloseOutlined className="text-red-600"/>,
						label: "Reject",
						confirm: "reject",
						available: record.tur_status_name === "Pending" ? 1 : 0,
					},
					]}
				/>
		},
	];

	return (
		<Card extra="w-full h-full p-4">
			<div className="h-full w-full overflow-x-auto">
				<Table
					columns={columns}
					dataSource={recordList.items}
					rowKey="tur_id"
					loading={recordList.requesting}
					pagination={{
						current: recordList.pagination.current_page,
						pageSize: recordList.pagination.per_page,
						total: recordList.pagination.total,
					}}
					onChange={handleTableChange}
				/>
			</div>
		</Card>
	);
};

export default (TimecardUpdateRequestTable);